import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout.component';
import { EmptyLayoutModule } from './layouts/empty/empty.module';
import { ClassicLayoutModule } from './layouts/vertical/classic/classic.module';
import { SettingsModule } from './common/settings/settings.module';
import { SharedModule } from '../shared/shared.module';
import { AuthLayoutModule } from './layouts/auth/auth.module';
import { LandingLayoutModule } from './layouts/landing/landing.module';

const layoutModules = [
  // Empty
  EmptyLayoutModule,

  // Auth
  AuthLayoutModule,

  // Vertical navigation
  ClassicLayoutModule,

  // Landing
  LandingLayoutModule
];

@NgModule({
  declarations: [LayoutComponent],
  imports: [SharedModule, SettingsModule, ...layoutModules],
  exports: [LayoutComponent, ...layoutModules],
})
export class LayoutModule {}
